function SocialChannel2() {
  return (
    <svg
      width={163}
      height={59}
      viewBox="0 0 163 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 57L67.1318 12H141.564H163"
        stroke="#242536"
        strokeOpacity="0.6"
      />
      <path
        d="M24 57L67.1318 12H141.564H163"
        stroke="url(#paint0_linear_2018_46)"
      />
      <path opacity="0.3" d="M1 57.5L56.2158 1H130.825H162" stroke="#242536" />
      <path opacity="0.3" d="M47 58L77.328 26H151.829H162" stroke="#242536" />
      <defs>
        <linearGradient
          id="paint0_linear_2018_46"
          x1={32}
          y1="30.5"
          x2="351.447"
          y2="30.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0674891" stopColor="#368DFF" stopOpacity={0} />
          <stop offset="0.206121" stopColor="#368DFF" />
          <stop offset="0.207969" stopColor="#368DFF" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>

  );
}

export default SocialChannel2;